import { render, staticRenderFns } from "./ElectronicIDLogin.vue?vue&type=template&id=22afcd7b&scoped=true"
import script from "./ElectronicIDLogin.vue?vue&type=script&lang=js"
export * from "./ElectronicIDLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22afcd7b",
  null
  
)

export default component.exports